import type { Store } from '../../types';
import type {
  PurchasePolicyAdditionalData,
  PurchasePolicyFlow,
  PurchasePolicyInput,
} from '../reducer/v2/purchasePolicy';

export const getPurchasePolicyInput = (state: Store): PurchasePolicyInput => ({
  ...state.purchasePolicy.input,
});

export const getPurchasePolicyFlow = (state: Store): PurchasePolicyFlow => state.purchasePolicy.flow;
export const getPurchasePolicyAdditionalData = (state: Store): PurchasePolicyAdditionalData => state.purchasePolicy.additionalData;
